import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import Events from "./events";
import { triggerMobileAppOrStoreRedirect } from "../utils/openAppRedirect";

const OBJECT_ID_RE = /^[a-f\d]{24}$/i;

/** /events/Goa → list; legacy /events/{objectId} → /event/{id} then city/slug */
const EventsOrDetails = () => {
  const { cityOrId } = useParams();

  useEffect(() => {
    if (OBJECT_ID_RE.test(cityOrId || "")) {
      triggerMobileAppOrStoreRedirect({ entityType: "events", entityId: cityOrId });
    }
  }, [cityOrId]);

  if (OBJECT_ID_RE.test(cityOrId || "")) {
    return <Navigate to={`/event/${cityOrId}`} replace />;
  }

  return <Events />;
};

export default EventsOrDetails;
